import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApmErrorHandler } from '@elastic/apm-rum-angular';
import { AuthComponent, AuthGuard, AdminGuard, RegisterComponent, ResetPasswordComponent, RemoverCadastroComponent } from './core';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard';

import { AferirDioComponent, DioComponent, FormDioComponent, ViewDioComponent } from './dio';
import { BeneficiariaComponent, ViewBeneficiariaComponent, FormBeneficiariaComponent } from './beneficiaria';
import { AnotacaoComponent, FormCondutorComponent, ListCondutorComponent } from './condutor';
import { ContratoComponent, FormAlocacaoComponent, FormContratoComponent, ViewContratoComponent, FormTarifaComponent, ViewAlocacaoComponent } from './contrato';
import { EquipamentoComponent, FormEquipamentoCategoriaComponent, FormEquipamentoComponent, FormEquipamentoGrupoComponent, FormEquipamentoTipoComponent, ViewEquipamentoComponent } from './equipamento';
import { FaturamentoComponent, FormFaturamentoComponent, ViewFaturamentoComponent } from './faturamento';
import { FormLocaisApresentacaoComponent, FormOrgaoComponent, FormRegiaoAdminComponent, LocalidadeComponent, ViewOrgaoComponent } from './localidade';
import { DioNaoExecutadoComponent, EquipamentosExistentesComponent, RelatorioAfericoesComponent, RelatorioAprovacoesComponent, RelatorioComponent, RelatorioConsumoPorEquipamentoComponent, RelatorioDiosAferidasComponent, ValorBrutoBeneficiarioComponent, ValorBrutoMonetarioComponent, ValoresBrutosEquipamentosComponent, RelatorioDashboardBeneficiariaComponent, RelatorioDiosEncerradosAutomaticamenteComponent } from './relatorio';
import { ServicoComponent } from './servico';
import { FormUsuarioComponent, ProfileComponent, UsuarioComponent, ViewUsuarioComponent } from './usuario';
import { ConfigComponent, FormConfigComponent } from './config';

import { FormUsuarioAusenciaComponent } from './usuario/form-ausencia/form-ausencia.component';
import { RegrasCortesAfericaoComponent } from './config/regras-cortes-afericao/regras-cortes-afericao.component';
import { FormRegrasCortesAfericaoComponent } from './config/regras-cortes-afericao/form-regras-cortes-afericao/form-regras-cortes-afericao.component';
import { SystemConfigComponent } from './config/system-configs/system-config.component';
import { RelatorioAfericoesAferidorComponent } from './relatorio/relatorio-afericoes-aferidor/relatorio-afericoes-aferidor.component';
import { PrefixosSemDiosComponent } from './relatorio/prefixos-sem-dios/prefixos-sem-dios.component';
import { DiosPorPrefixoComponent } from './relatorio/dios-por-prefixo/dios-por-prefixo.component';
import { UsuariosPorBeneficiariaComponent } from './relatorio/usuarios-por-beneficiaria/usuarios-por-beneficiaria.component';
import { ViewBeneficiariaColigadaComponent } from './beneficiaria/view-beneficiaria-coligada/view-beneficiaria-coligada.component';
import { FormBeneficiariaColigadaComponent } from './beneficiaria/form-beneficiaria-coligada/form-beneficiaria-coligada.component';
import { PendenciasDeFaturamentoComponent } from './relatorio/pendencias-de-faturamento/pendencias-de-faturamento.component';
import { AprovacoesMarcelinhoComponent } from './config/aprovacoes-marcelinho/aprovacoes-marcelinho.component';
import { CancelamentoMassaComponent } from './config/cancelamento-em-massa/cancelamento-em-massa.component';

const routes: Routes = [
    { path: 'sign-in', component: AuthComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'remover-cadastro', component: RemoverCadastroComponent },

    { path: '', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AdminGuard] },
    
    { path: 'dio', children: [
        { path: '', component: DioComponent },
        { path: 'novo', component: FormDioComponent },
        { path: ':idDio/aferir', component: AferirDioComponent },
        { path: ':idDio/mapa', component: AferirDioComponent },
        { path: ':idDio/editar', component: FormDioComponent },
        { path: ':idDio/incluir-sei', component: FormDioComponent },
        { path: ':idDio/visualizar', component: ViewDioComponent },
    ]},
    { path: 'pendencias/:statusExecucao', component: DioComponent },
    { path: 'beneficiaria', canActivate: [AuthGuard], children: [
        { path: '', component: BeneficiariaComponent },
        { path: 'nova', component: FormBeneficiariaComponent },
        { path: ':idBeneficiaria/editar', component: FormBeneficiariaComponent },
        { path: ':idBeneficiaria/visualizar', component: ViewBeneficiariaComponent },

        { path: ':idBeneficiaria/condutor/novo', component: FormCondutorComponent },
        { path: ':idBeneficiaria/condutor/:idCondutor/editar', component: FormCondutorComponent },
        { path: ':idBeneficiaria/condutor/:idCondutor/anotacao', component: AnotacaoComponent },
    ]},
    { path: 'condutores', children: [
        { path: '', component: ListCondutorComponent },
        { path: 'novo', component: FormCondutorComponent },
        { path: ':idCondutor/editar', component: FormCondutorComponent },
        { path: ':idCondutor/anotacao', component: AnotacaoComponent },
    ]},
    { path: 'contrato', canActivate: [AuthGuard], children: [
        { path: '', component: ContratoComponent },
        { path: 'novo', component: FormContratoComponent },
        { path: ':idContrato/editar', component: FormContratoComponent },
        { path: ':idContrato/visualizar', component: ViewContratoComponent },
        
        { path: ':idContrato/alocacao/nova', component: FormAlocacaoComponent },
        { path: ':idContrato/alocacao/:idAlocacao/editar', component: FormAlocacaoComponent },
        { path: ':idContrato/alocacao/:idAlocacao/visualizar', component: ViewAlocacaoComponent },

        { path: ':idContrato/tarifa/nova', component: FormTarifaComponent },
        { path: ':idContrato/tarifa/:idTarifa/editar', component: FormTarifaComponent },

        { path: ':idContrato/dio/novo', component: FormDioComponent },
        { path: ':idContrato/dio/:idDio/editar', component: FormDioComponent },
    ]},
    { path: 'equipamento', canActivate: [AuthGuard], children: [
        { path: '', component: EquipamentoComponent },
        { path: 'novo', component: FormEquipamentoComponent },
        { path: ':id/editar', component: FormEquipamentoComponent },
        { path: ':id/visualizar', component: ViewEquipamentoComponent },

        { path: 'categoria/nova', component: FormEquipamentoCategoriaComponent },
        { path: 'categoria/:id/editar', component: FormEquipamentoCategoriaComponent },

        { path: 'grupo/novo', component: FormEquipamentoGrupoComponent },
        { path: 'grupo/:id/editar', component: FormEquipamentoGrupoComponent },

        { path: 'tipo/novo', component: FormEquipamentoTipoComponent },
        { path: 'tipo/:id/editar', component: FormEquipamentoTipoComponent },
    ]},
    { path: 'faturamentos', canActivate: [AuthGuard], children: [
        { path: '', component: FaturamentoComponent },
        { path: 'novo', component: FormFaturamentoComponent },
        { path: ':idFaturamento/visualizar', component: ViewFaturamentoComponent },
    ]},
    { path: 'localidade', canActivate: [AuthGuard], children: [
        { path: '', component: LocalidadeComponent },
        { path: 'regiao-admin/nova', component: FormRegiaoAdminComponent },
        { path: 'regiao-admin/:id/editar', component: FormRegiaoAdminComponent },
        { path: 'orgao', children: [
            { path: 'novo', component: FormOrgaoComponent },
            { path: ':idOrgao/editar', component: FormOrgaoComponent },
            { path: ':idOrgao/visualizar', component: ViewOrgaoComponent },
            { path: ':idOrgao/locais-apresentacao/novo', component: FormLocaisApresentacaoComponent },
            { path: ':idOrgao/locais-apresentacao/:idLocal/editar', component: FormLocaisApresentacaoComponent },
        ]},
    ]},
    { path: 'relatorio', canActivate: [AuthGuard], children: [
        { path: '', component: RelatorioComponent },
        { path: 'dio-nao-executado', component: DioNaoExecutadoComponent },
        { path: 'consumo-por-equipamento', component: RelatorioConsumoPorEquipamentoComponent },
        { path: 'valor-bruto-beneficiario', component: ValorBrutoBeneficiarioComponent },
        { path: 'valores-brutos-equipamentos', component: ValoresBrutosEquipamentosComponent },
        { path: 'valor-bruto-monetario', component: ValorBrutoMonetarioComponent },
        { path: 'equipamentos-existentes', component: EquipamentosExistentesComponent },
        { path: 'relatorio-afericoes', component: RelatorioAfericoesComponent },
        { path: 'relatorio-dios-aferidas', component: RelatorioDiosAferidasComponent },
        { path: 'relatorio-afericoes-aferidores', component: RelatorioAfericoesAferidorComponent },
        { path: 'faturamentos', component: FaturamentoComponent },
        { path: 'prefixos-sem-dios', component: PrefixosSemDiosComponent },
        { path: 'dios-por-prefixo', component: DiosPorPrefixoComponent },
        { path: 'usuarios-por-beneficiaria', component: UsuariosPorBeneficiariaComponent },
        { path: 'pendencias-de-faturamento', component: PendenciasDeFaturamentoComponent },
        { path: 'dashboard-beneficiaria', component: RelatorioDashboardBeneficiariaComponent },
        { path: 'dios-encerrados-automaticamente', component: RelatorioDiosEncerradosAutomaticamenteComponent },
        { path: 'aprovacoes', component: RelatorioAprovacoesComponent },
    ]},
    { path: 'servico', canActivate: [AuthGuard], component: ServicoComponent },
    { path: 'usuario', canActivate: [AuthGuard], children: [
        { path: '', component: UsuarioComponent },
        { path: 'novo', component: FormUsuarioComponent },
        { path: ':id/editar', component: FormUsuarioComponent },
        { path: ':id/visualizar', component: ViewUsuarioComponent },
        { path: ':id/ausencia', component: FormUsuarioAusenciaComponent }
    ]},
    { path: 'configuracoes', canActivate: [AuthGuard], children: [
        { path: '', component: ConfigComponent },
        { path: ':idConfig/editar', component: FormConfigComponent },
        { path: 'configuracoes-sistema', component: SystemConfigComponent },
        { path: 'configuracoes-sistema/:idConfig/editar', component: FormConfigComponent },
        { path: 'regras-apontamentos', component: RegrasCortesAfericaoComponent },
        { path: 'regras-apontamentos/nova', component: FormRegrasCortesAfericaoComponent },        
        { path: 'regras-apontamentos/:idRegra/editar', component: FormRegrasCortesAfericaoComponent },
        { path: 'gerir-coligadas-novacap', component: ViewBeneficiariaColigadaComponent },
        { path: 'gerir-coligadas-novacap/nova', component: FormBeneficiariaColigadaComponent },
        { path: 'aprovacoes-do-marcelinho', component: AprovacoesMarcelinhoComponent },
        { path: 'cancelamento-em-massa', component: CancelamentoMassaComponent },
    ]},    
    { path: 'perfil', component: ProfileComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'sign-in' },    
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [{ provide: ErrorHandler, useClass: ApmErrorHandler }]
})
export class AppRoutingModule { }
